// Shared, queued app dialogs. Confirm/prompt callers must await the result.
let nextId = 0;
const queue = [];
const listeners = new Set();
const notify = () => listeners.forEach(listener => listener());
function request(kind, message, options = {}) {
  return new Promise(resolve => {
    queue.push({ ...options, id: ++nextId, kind, message: String(message ?? ""), resolve });
    notify();
  });
}
export const appAlert = (message, options) => request("alert", message, options);
export const appConfirm = (message, options) => request("confirm", message, options);
export const appPrompt = (message, defaultValue = "", options) =>
  request("prompt", message, { ...options, defaultValue: String(defaultValue ?? "") });
export const currentDialog = () => queue[0] || null;
export function subscribeDialogs(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function settleDialog(id, value) {
  if (queue[0]?.id !== id) return;
  const dialog = queue.shift();
  dialog.resolve(value);
  notify();
}
